module.exports = __webpack_public_path__ + "202473:5e26845903691f5ef60a/img/group_8.a1f4738.png";